import { Trash } from "lucide-react";
import { isMyStaging, ME_CLIENT } from "../data/people";
import { liveItems } from "../lib/domain";
import { notify } from "../lib/notify";
import { cn } from "../lib/utils";
import { useStore } from "../store";
import type { Task } from "../types";
import { Button } from "./ui/button";

/**
 * Кто может удалить публикацию (25.10.2026): автор, исполнитель и постановщик — на
 * любом шаге. Раньше снять тему мог только постановщик и только до начала
 * работы, а дубли и ролики, вышедшие под другой темой, висели в «Публикации».
 */
export function canDeleteTopic(task: Task): boolean {
  return task.creator === ME_CLIENT || (Boolean(task.editor) && task.editor === ME_CLIENT) || isMyStaging(task);
}

/**
 * «Удалить публикацию». Сервер не стирает её, а прячет: час её можно вернуть,
 * а сразу — «Отменить» в тосте. Приложенный к ней пост снова свободен.
 *
 * Без окна «Вы уверены?» (02.11.2026): защита двойная была лишней — запрос
 * уходит, только когда тост догорел, и «Отменить» его не пускает.
 */
export function DeleteTopic({ task, variant = "link", className }: { task: Task; variant?: "link" | "button"; className?: string }) {
  const cancelTask = useStore((s) => s.cancelTask);
  const restore = useStore((s) => s.restore);
  if (!canDeleteTopic(task)) return null;

  const onDelete = () => {
    const published = liveItems(task).some((i) => i.status === "published");
    const snap: Task = JSON.parse(JSON.stringify(task));
    cancelTask(task.id);
    notify(published ? "Публикация удалена — её пост ушёл из «Видео»" : "Публикация удалена", { icon: "info", undo: () => restore(snap) });
  };

  if (variant === "button") {
    return (
      <Button variant="destructive" className={className} onClick={onDelete}>
        <Trash />
        Удалить публикацию
      </Button>
    );
  }
  return (
    <button
      type="button"
      onClick={onDelete}
      className={cn("flex items-center gap-1.5 text-[13px] font-medium text-muted-foreground hover:text-rework-fg", className)}
    >
      <Trash className="size-3.5" />
      Удалить публикацию
    </button>
  );
}
